import { render } from "./UserDetail.vue?vue&type=template&id=3dd9b1f2&scoped=true&ts=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"

import "./UserDetail.vue?vue&type=style&index=0&id=3dd9b1f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd9b1f2"]])

export default __exports__